import { Link } from 'react-router-dom'
import { useState, useEffect } from 'react'
import { createClient } from '@/lib/supabase-client'

export default function PublicFooter() {
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  const supabase = createClient()

  useEffect(() => {
    checkAuth()
  }, [])

  const checkAuth = async () => {
    const { data: { session } } = await supabase.auth.getSession()
    setIsAuthenticated(!!session)
  }

  return (
    <footer className="border-t border-gray-200 dark:border-slate-800 py-12 mt-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-5 gap-8">
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <img
                src="/gistmag-rect-logo.png"
                alt="GistMag"
                className="h-8 w-auto"
              />
            </div>
            <p className="text-gray-600 dark:text-gray-400 text-sm">
              AI-powered tools for alt text, speech, blog metadata, site audits, and indexing.
            </p>
          </div>
          <div>
            <h4 className="font-semibold text-gray-900 dark:text-white mb-4">Product</h4>
            <ul className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
              <li><Link to="/dashboard" className="hover:text-primary-600 dark:hover:text-primary-400 transition">Dashboard</Link></li>
              <li><Link to="/dashboard/api-key" className="hover:text-primary-600 dark:hover:text-primary-400 transition">API</Link></li>
              <li><Link to="/dashboard/integrations" className="hover:text-primary-600 dark:hover:text-primary-400 transition">Integrations</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold text-gray-900 dark:text-white mb-4">Resources</h4>
            <ul className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
              <li>
                <Link to="/about" className="hover:text-primary-600 dark:hover:text-primary-400 transition">
                  About
                </Link>
              </li>
              <li>
                <a
                  href="https://docs.gistmag.co.uk/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-primary-600 dark:hover:text-primary-400 transition"
                >
                  API Docs
                </a>
              </li>
              <li>
                <Link
                  to="/blog"
                  className="hover:text-primary-600 dark:hover:text-primary-400 transition"
                >
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/dashboard/analytics" className="hover:text-primary-600 dark:hover:text-primary-400 transition">
                  Analytics
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold text-gray-900 dark:text-white mb-4">Legal</h4>
            <ul className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
              <li>
                <Link to="/privacy" className="hover:text-primary-600 dark:hover:text-primary-400 transition">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="hover:text-primary-600 dark:hover:text-primary-400 transition">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold text-gray-900 dark:text-white mb-4">Account</h4>
            <ul className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
              {isAuthenticated ? (
                <>
                  <li><Link to="/dashboard" className="hover:text-primary-600 dark:hover:text-primary-400 transition">Dashboard</Link></li>
                  <li><Link to="/dashboard/settings" className="hover:text-primary-600 dark:hover:text-primary-400 transition">Settings</Link></li>
                </>
              ) : (
                <>
                  <li><Link to="/auth/login" className="hover:text-primary-600 dark:hover:text-primary-400 transition">Sign In</Link></li>
                  <li><Link to="/auth/signup" className="hover:text-primary-600 dark:hover:text-primary-400 transition">Sign Up</Link></li>
                </>
              )}
            </ul>
          </div>
        </div>
        <div className="mt-8 pt-8 border-t border-gray-200 dark:border-slate-800 flex flex-col md:flex-row justify-between items-center text-sm text-gray-600 dark:text-gray-400 gap-4">
          <p>&copy; {new Date().getFullYear()} GistMag. All rights reserved.</p>
          <div className="flex items-center space-x-1.5">
            <span>by</span>
            <a
              href="https://www.olaverse.co.uk/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center space-x-1.5 text-gray-900 dark:text-white hover:text-primary-600 dark:hover:text-primary-400 transition-colors font-semibold"
            >
              <img
                src="https://www.olaverse.co.uk/lovable-uploads/b3a511f8-03ca-4129-b1c8-d08e38558934.png"
                alt="Olaverse Labs"
                className="h-4 w-4"
              />
              <span>olaverse labs</span>
            </a>
          </div>
        </div>
      </div>
    </footer>
  )
}

